<template>
    <div v-if="!!item" class="d-flex justify-center align-center fill-height primary lighten-5 primary--text">
        {{ name }}
    </div>
</template>

<script>
import { initExpoEmployer, initExpoMatching } from "@/assets/variables/inits";

export default {
    props: {
        mode: { type: String, default: "form" },
        value: { type: Object, default: initExpoMatching }, // form
        employer: { type: Object, default: initExpoEmployer },
        matchings: { type: Array, default: () => [] },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },

        date: { type: String, default: null },
        time: { type: Number, default: 8 },
    },
    computed: {
        datetime() {
            return this.$dayjs(this.date).set("hour", this.time);
        },
        item() {
            return this.matchings.find((item) => this.datetime.isSame(item.interviewAt));
        },
        name() {
            if (this.isUserEmployee) return this.item?.employer?.info?.name;
            if (this.isUserEmployer) return this.item?.employee?.info?.name;
        },
    },
};
</script>
